<template>
      <div class="main-container" >
         
      <div  id="activate-container" class="pay">
           <div class="overlay"></div>
    <div class="content">   <h1>Activate device</h1>
      <p>To activate your device, enter your device ID displayed on the screen of the TV application. Provide your email
        address where you will receive a confirmation of your device activation.</p>
      <div class="price-list">
        <span class="price">6.99€ </span> <br>
  
      </div>
      <!-- Input za dodatne podatke -->
      <form id="payment-form">
        <label for="deviceId">Your device ID:</label>
        <input type="text" id="deviceId" v-model="deviceId" required />
  
        <label for="userEmail">Your email:</label>
        <input type="email" id="userEmail" v-model="userEmail" required />
      </form>
   
      <!-- PayPal dugme -->
      <span style="display:flex; justify-content: center;" id="paypal-button-container-sub" class="paypal-container"></span>

      <p>support@streamboxtv.live</p></div>
    </div>
    <div id="line"></div>
    </div>
  
  
  </template>
    
    <script>
    /* eslint-disable no-undef */
    export default {
      data() {
        return {
          deviceId: "",
          userEmail: "",
        };
      },
      mounted() {
        this.loadPayPalScript();
  
      },
      methods: {
        loadPayPalScript() {
          if (!window.paypal) {
            const script = document.createElement("script");
            script.src =
  "https://www.paypal.com/sdk/js?client-id=AamyVpS6CMEk3l-W7tUdIsNrxsGvewHO2xxeWLwyVQ8EIs_oHi6RQSMhfPptirGi18SycpDhP8nG3Ua6&vault=true&intent=subscription";
                                 
              script.onload = this.renderPayPalButton;
            document.body.appendChild(script);
          } else {
            this.renderPayPalButton();
          }
        },
        renderPayPalButton() {
  paypal.Buttons({
    style: {
      shape: 'pill',
      color: 'gold',
      layout: 'vertical',
      label: 'subscribe'
    },
    createSubscription: function(data, actions) {
      return actions.subscription.create({
        plan_id: 'P-9BY41912LS824153ENA5W4TY' // Tvoj plan ID
      });
    },
    onApprove: async (data) => {
      const subscriptionId = data.subscriptionID;
      console.log("✅ Sub ID:", subscriptionId);

      const formData = {
        subscriptionId,
        deviceId: this.deviceId,
        userEmail: this.userEmail,
      };

      fetch("https://app.streamboxtv.live/api3002/api/payment/success", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            alert("✅ Subscription successful and verified!");
          } else {
            alert("⚠️ Subscription created but verification failed.");
          }
        })
        .catch((err) => {
          console.error("❌ Backend error:", err);
          alert("⚠️ Subscription created but there was an error.");
        });
    },
    onCancel: () => {
      alert("❌ Subscription cancelled.");
    },
    onError: (err) => {
      console.error("❌ Subscription error:", err);
      alert("❌ An error occurred during subscription.");
    },
  }).render("#paypal-button-container-sub");

}
      },
    };
  </script>
    
    <style scoped>
  
    /* Glavna komponenta */
    p {
      color: white;
   
      margin-bottom: 50px;
    }
  
    .pay {
    position:relative;
      /* Tamno siva pozadina */
      color: white;
      /* Bele labele i tekst */
      padding: 40px;
  
      /* Zaobljeni uglovi */
      width: 100%;
      /* Širina komponente */

      /* Centriranje komponente */
      text-align: center;
      /* Centriranje sadržaja */
   background: url("@/assets/back.jpg") no-repeat center center;
      background-size: cover;
    }
  
    /* Naslov */
    h1 {
      font-weight: 500;
    
      color: white;
      /* Narandžasta boja naslova */
      margin:30px 0px;
    }
  
    /* Forma */
    form {
      margin-bottom: 20px;
    }
  
    /* Labele */
    /* Labele */
    label {
      display: block;
      margin-bottom: 5px;
      color: white;
      /* Bele labele */
      font-weight: bold;
      text-align: left;
      /* Poravnanje teksta u levo */
    }
  
    /* Polja za unos */
    input[type="url"],
    input[type="text"],
    input[type="email"] {
      width: 100%;
      /* Širina polja */
      padding: 10px;
    outline:none;
      border-radius: 5px;
      /* Zaobljeni uglovi */
      font-size: 14px;
      box-sizing: border-box;
      background-color: #d8d8d8;
      /* Tamno siva pozadina polja */
      color: black;
      /* Bela boja teksta */
      margin-bottom: 15px;
  
      border: 1px solid #0099ff;
    }
  
    /* Centriranje PayPal dugmadi */
    .paypal-container {
      display: flex;
      justify-content: center;
      /* Horizontalno centriranje */
      align-items: center;
      /* Vertikalno centriranje */
      flex-wrap: wrap;
      /* Omogućava prelamanje dugmadi */
      gap: 10px;
      /* Razmak između dugmadi */
    }
  
    #paypal-button-container {
      margin-left: auto;
      margin-right: auto;
      max-width: 500px;
      margin-top: 0.625rem;
    }
  
    .paypal-container>div {
      flex: 1 1 auto;
      /* Dugmad zauzimaju prostor ravnomerno */
      max-width: 150px;
      /* Maksimalna širina svakog dugmeta */
    }
    .price {
  display: inline-block;
  padding: 15px 35px;
  font-size: 24px;
  font-weight: bold;
  color: white;
  background: linear-gradient(135deg, #FFD700, #FF8C00); /* zlatno-žuti u narandžasti */
  border-radius: 12px;
  position: relative;
  z-index: 0;
  overflow: hidden;
  text-shadow:1px 1px 1px black;
  box-shadow: 0 0 12px rgba(255, 200, 0, 0.6);
}

.price::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  background-color: rgba(255, 255, 255, 0.1); /* blag unutrašnji sloj */
  border-radius: 10px;
  z-index: -1;
}



    /* Animacija za "sjaj" */
  
    #price span {
      font-size: 0.6em;
    }
  
  
  
    #buttons-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  
    .buttons-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  
    .buttons-container {
      /* Dodaj željene stilove */

      /* Primer promene */
      padding: 120px;
      border-radius: 5px;
    }
    #line {
    position: relative;
    top: 99.5%;
    left:0;
    width: 100vw;
    height: 2px;
    background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(0,99,255,1) 9%, rgba(23,46,147,1) 27%, rgba(222,0,127,1) 46%, rgba(0,72,202,1) 65%, rgba(171,0,78,1) 82%, rgba(9,9,121,1) 100%, rgba(0,76,196,1) 100%);
    background-size: 200% 100%;
    animation: move-gradient 10s linear infinite;
    box-shadow: 0px 5px 20px rgb(0, 0, 0);
    animation-direction: alternate;
  }
  
  
  @keyframes move-gradient {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 100% 0%;
    }
  }
  /* Glavna sekcija - crna pozadina, full širina */
.pay {
  width: 100%;
  background-color: #000;
  padding: 20px 0;
  padding-top:50px;
}

/* Wrapper forme */
.pay form,
.price-list,
#paypal-button-container,
h1,
p {
      text-shadow:1px 1px 5px rgba(0, 0, 0, 0.671);
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

/* Centriran sadržaj u formi sa padding-om sa strane */
.pay form {

  padding: 40px;


  margin-top: 30px;
 
}

/* Naslov */


/* Opis */
.pay p {
  color: white;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 40px auto;
  padding: 0 20px;
}

/* Paypal centriranje */
#paypal-button-container {
  max-width: 400px;
  margin: 40px auto 0 auto;
}
#paypal-button-container-sub {
  max-width: 400px;
  margin: 40px auto 0 auto;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(31, 121, 255, 0.199);
  z-index: 1;
}
.main-container{
 position: relative;
}
.content{
  position:relative;
  z-index:2;
}
  </style>